// extracted by mini-css-extract-plugin
export var actions = "_ma-5";
export var assistantBubble = "_ma-3";
export var assistantRow = "_ma-6";
export var bubble = "_ma-0";
export var humanAvatar = "_ma-4";
export var inlineToolCard = "_ma-1";
export var userBubble = "_ma-2";